import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'rc-dev-mode-banner',
  styles: `
    .dev-indicator {
      position: fixed;
      bottom: 0.75rem;
      right: 0.75rem;
      z-index: 9999;
      font-size: 0.75rem;
      font-weight: 700;
      font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #fff;
      background: rgba(251, 133, 0, 0.7);
      backdrop-filter: blur(4px) saturate(0);
      padding: 0.3rem 0.6rem;
      border-radius: 4px;
      cursor: default;
      user-select: none;
      pointer-events: none;
      line-height: 1;
    }
  `,
  template: `
    @if (devMode) {
      <div class="dev-indicator">dev</div>
    }
  `,
})
export class RcDevModeBannerComponent {
  public readonly devMode = !environment.production;
}
